module.exports = __webpack_public_path__ + "static/scale-model-of-cars-land-in-fullerton-california-6cab090efeae73a42bd4a8b3c086e37f.png";